import http_request from './http_request'
import config from 'config'

function getOnboardingGuideData() {
	return http_request.get(`${config.api}onboarding_guide`)
		.send()
}

function completeCard(type) {
	return http_request.put(`${config.api}onboarding_guide`)
		.send({
			cardType: type,
		})
}

function toggleOnboardingGuideActivation() {
	return http_request.put(`${config.api}onboarding_guide/toggle`)
		.send()
}

export default {
	getOnboardingGuideData,
	completeCard,
	toggleOnboardingGuideActivation,
}
